import { initializeApp } from 'firebase/app'
import { 
  getFirestore, 
  collection, 
  getDocs, 
  addDoc, 
  query, 
  orderBy,
  connectFirestoreEmulator,
  enableIndexedDbPersistence,
  enableMultiTabIndexedDbPersistence,
  initializeFirestore,
  CACHE_SIZE_UNLIMITED
} from 'firebase/firestore'

// 检查环境变量
const checkEnvVariables = () => {
  const requiredVars = [
    'VITE_FIREBASE_API_KEY',
    'VITE_FIREBASE_AUTH_DOMAIN',
    'VITE_FIREBASE_PROJECT_ID',
    'VITE_FIREBASE_STORAGE_BUCKET',
    'VITE_FIREBASE_MESSAGING_SENDER_ID',
    'VITE_FIREBASE_APP_ID'
  ];

  const missingVars = requiredVars.filter(varName => !import.meta.env[varName]);
  
  if (missingVars.length > 0) {
    console.error('缺少必要的环境变量:', missingVars);
    return false;
  }
  return true;
}

// Firebase配置对象
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

console.log('Firebase配置:', {
  ...firebaseConfig,
  apiKey: firebaseConfig.apiKey ? '已设置' : '未设置',
  appId: firebaseConfig.appId ? '已设置' : '未设置'
})

let app
let db

const initializeFirebase = async () => {
  try {
    if (app && db) {
      console.log('Firebase已经初始化')
      return { app, db }
    }

    console.log('开始初始化Firebase...')
    
    app = initializeApp(firebaseConfig)
    console.log('Firebase应用初始化成功')

    db = getFirestore(app)
    console.log('Firestore实例创建成功')
    
    return { app, db }
  } catch (error) {
    console.error('Firebase初始化错误:', error)
    throw error
  }
}

export const ensureFirebaseInitialized = async () => {
  try {
    const result = await initializeFirebase()
    if (!result?.app || !result?.db) {
      throw new Error('Firebase初始化失败')
    }
    return result
  } catch (error) {
    console.error('确保Firebase初始化时出错:', error)
    throw error
  }
}

// 自动初始化Firebase
initializeFirebase().catch(error => {
  console.error('Firebase初始化过程中出错:', error)
})

// 导出所需的Firebase功能
export { 
  db,
  collection,
  getDocs,
  addDoc,
  query,
  orderBy
} 